import cleanDeep from "clean-deep";
import { useEffect } from "react";
import { NotificationManager } from "react-notifications";
import { connect } from "react-redux";
import { Actions as ALLOWANCE_ACTIONS } from "../../../store/actions/allowanceActions";
import { Actions as COMPANY_ACTIONS } from "../../../store/actions/companyActions";

import { CheckCircleIcon, PlusIcon } from "@heroicons/react/20/solid";
import AllowanceRow from "../allowance-tab/AllowanceRow";
import AdvancedSettingsModal from "../modals/AdvancedSettingsModal";
import NoItemsRow from "@/common/NoItemsRow";
import { cloneDeep } from "lodash";
import UpdatePeriodTypeModal from "../modals/UpdatePeriodTypeModal";

const Payroll = ({
	allowances,
	allowanceGetList,
	addAllowance,
	updateCompanyDetails,
	currentOrg,
	settings,
	disabled,
	jurisdiction,
}) => {
	const onSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();
		const invalidAllowances =
			allowances?.length > 0 &&
			allowances?.find(
				(allowance) => !(allowance.name && allowance.method && allowance.hasOwnProperty("taxable")),
			);

		if (invalidAllowances)
			return NotificationManager.error("Please ensure all fields are filled before saving!", "Allowances");

		updateCompanyDetails(
			cleanDeep(
				{
					org: String(currentOrg),
					allowances: allowances?.map((allowance) => {
						allowance.temporary = undefined;
						return allowance;
					}),
				},
				{ emptyStrings: false, emptyArrays: false, emptyObjects: false },
			),
		);
	};

	useEffect(() => {
		if (!allowances) {
			allowanceGetList();
		}
	}, []);

	return (
		<form
			onSubmit={onSubmit}
			style={{ paddingBottom: 30 }}
			className="px-8"
		>
			<UpdatePeriodTypeModal />
			<AdvancedSettingsModal />
			<div className="clearfix" />

			<div className="form-section col-xs-12">
				<div className="col-xs-12">
					<div className="pull-left">
						<h4>{jurisdiction == "UK" ? "Pay Items" : "Allowances"}</h4>
					</div>
					{!disabled && (
						<button
							className="btn btn-success pull-right"
							type="button"
							id="add-allowance-type"
							onClick={() => {
								console.log("add allowance");
								addAllowance();
							}}
						>
							<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
							<div style={{ float: "left" }}>Add {jurisdiction == "UK" ? "Pay Item" : "Allowances"}</div>
						</button>
					)}
				</div>
				<div className="col-xs-12 pl-0 pb-6">
					{allowances?.length ? (
						<>
							{allowances?.map((allowance) => (
								<AllowanceRow
									key={allowance.id}
									allowance={allowance}
								/>
							))}
						</>
					) : (
						<table
							id="table-timesheets"
							className="js-table-sections table table-hover"
						>
							<NoItemsRow name={jurisdiction == "UK" ? "Pay Items" : "Allowances"} />
						</table>
					)}
				</div>
			</div>

			<div className="clearfix" />
			<div className="col-xs-12 pr-0 text-right">
				{!disabled && (
					<button
						className="btn btn-success"
						type="submit"
					>
						<CheckCircleIcon style={{ height: "1.5em", float: "left" }} />
						<div style={{ float: "left" }}>Save</div>
					</button>
				)}
			</div>
		</form>
	);
};

const mapStateToProps = (state) => {
	const settings = cloneDeep(state.company?.settings);

	if (typeof settings?.showEmployerContributions == "undefined") {
		settings.showEmployerContributions = true;
	}

	return {
		jurisdiction: state.company?.settings?.jurisdiction,
		allowances: state.company?.settings?.allowances,
		currentOrg: state.company?.settings?.org,
		settings,
		disabled:
			state?.permissions?.my?.permissions?.settings == "Read" || state?.company?.settings?.status == "Archived",
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateCompanyDetails: (body) => dispatch(COMPANY_ACTIONS.updateCompanyDetails(body)),
	addAllowance: () => dispatch(ALLOWANCE_ACTIONS.addAllowance(null)),
	allowanceGetList: () => dispatch(ALLOWANCE_ACTIONS.allowanceGetList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Payroll);
